import '@root-config/global/setWebpackPublicPath'
import '@root-config/global/errorHandlers'
import '@root-config/global/initLoaders'

import { patchGlobalStorage } from '@lasso/shared/hooks'
import { initYup } from '@lasso/shared/validation'

import { config, getRedirectPath } from '@root-config/config'
import { initDatadog, startDatadogViewTracking } from '@root-config/global/datadog'
import { initRouter, preloadApp, registerApplications, startApplication } from '@root-config/singleSpa'

patchGlobalStorage()
initYup()
initDatadog()

await preloadApp('@lasso/root-app')

initRouter(getRedirectPath)
registerApplications(config)
startDatadogViewTracking(config)
startApplication()
